(function($) {

	'use strict';

	var init = function() {
		var toggle_menu_mobile = $('.js-toggle-header-mobile');
		toggleMobileSubMenu();

		toggle_menu_mobile.on('click', toggleMobileMenu);
	};

	var toggleMobileMenu = function (e) {
		var target = $(e.currentTarget),
			parent = target.parent();

		target.toggleClass('opened');
		parent.toggleClass('closed');
		target.closest('.js-header-mobile').toggleClass('opened');
	};

	var toggleMobileSubMenu = function(){
        
        $('.js-header-mobile-main .menu-item-has-children').on('click', function(e){
            
            if(window.innerWidth > 992 || $(e.target).is('a')) {
                return;
            }

            e.preventDefault();

            var target = $(e.currentTarget),
            	subMenu = target.children('.sub-menu'),
            	list = target.parent();
            
            $(this).toggleClass('subActive');
            list.toggleClass('subActive');
            $('.js-header-mobile-main .menu-item-has-children').not($(this)).removeClass('subActive');
            
        });
        
    };

	$(document).ready(function() {
		init();
	});

})(jQuery);
